// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import DataTableRow from "@steiner/MobiusOverrides/DataTable/DataTableRow";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
});

interface OwnProps {
    carouselId: string;
    product: ProductModel;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface RequiredProductRowStyles {
    unitOfMeasure?: TypographyPresentationProps;
    price?: ProductPriceStyles;
    productTitle?: LinkPresentationProps;
    wrapperLink?: LinkPresentationProps;
}

export const requiredProductRowStyles: RequiredProductRowStyles = {};

const styles = requiredProductRowStyles;

const RequiredProductRow = ({
    carouselId,
    product,
    productInfo,
}: Props) => {

    const updateQuantity = (qtyOrdered: number) => { };

    const updateUnitOfMeasure = (unitOfMeasure: string) => { };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    return (
        <ProductContext.Provider value={productContext}>
            <DataTableRow key={product.id}>
                <DataTableCell>
                    <Link href={product.canonicalUrl} {...styles.productTitle}>{product.productTitle}</Link>
                </DataTableCell>
                <DataTableCell>
                    <Link href={product.canonicalUrl} {...styles.wrapperLink}>
                        <ProductPrice product={productContext} extendedStyles={styles.price} />
                    </Link>
                </DataTableCell>
                <DataTableCell>
                    <Link href={product.canonicalUrl} {...styles.wrapperLink}>
                        {translate("Total Avail:")}&nbsp;
                        <Typography>
                            {productInfo.inventory?.qtyOnHand || "0"} &nbsp;
                            {productInfo.unitOfMeasure &&
                                <Typography {...styles.unitOfMeasure}>/{productInfo.unitOfMeasure}</Typography>
                            }
                        </Typography>
                    </Link>
                </DataTableCell>
            </DataTableRow>
        </ProductContext.Provider>
    );
};

export default connect(mapStateToProps)(RequiredProductRow);
